import LocationsModel from '../models/LocationsModel';

export default class LocationsCollection extends Backbone.Collection {
  constructor(options) {
    super(options);
    this.model = LocationsModel;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;
    let msLocationId;
    let msLocation;

    switch (actionType) {
      case ActionTypes.GET_LOCATION:
        Utils.setMakeshiftTokenHeader();
        msLocationId = payload.postData[Utils.getEndpointParam('LOCATION_ID_PARAM')];
        msLocation = LocationStore.getLocationById(msLocationId, payload.postData.target);
        if (!_.isEmpty(msLocation)) {
          LocationStore.trigger(
            'load:success',
            msLocation,
            msLocation.attributes,
            payload.postData.target,
          );
        } else {
          const url =
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
            appConstants.ApiPaths.API_VERSION_PATH +
            appConstants.EndPoints.GET_LOCATIONS.replace('%d', payload.postData[Utils.getEndpointParam('LOCATION_ID_PARAM')]);

          LocationStore.fetch({
            traditional: true,
            data: { target: payload.postData.target },
            url,
            type: 'GET',
            success: LocationStore.onLocationHandler,
            fail: LocationStore.onLocationError,
          });
        }
        break;
    }
  }
}
